module.exports = __webpack_public_path__ + "img/svg/background-create-match-success-modal.456e4bc4a6645ff37394707bb6f08636.svg";